import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFormsModule } from 'ng2-validation';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask';

import { PoliticaPrivacidadeComponent } from './components/politica-privacidade/politica-privacidade.component';
import { LoginComponent } from './components/login/login.component';
import { ChangePasswordComponent } from './components/change-password.component';
import { RedefinirSenhaComponent } from './components/redefinir-senha/redefinir-senha.component';
import { AuthSsoComponent } from './components/auth-sso.component';
import { EsqueciMinhaSenhaComponent } from './components/esqueci-minha-senha/esqueci-minha-senha.component';

import { AuthService } from './services/auth.service';
import { Oauth2TokenService } from './services/oauth2-token.service';
import { LocalStorageService } from './services/local-storage.service';
import { DefaultRequestOptionsService } from './services/default-request-options.service';
import { UserWebService } from './services/user.web.service';
import { LoginService } from './services/login.service';
import { OAuthService } from './services/oauth.service';
import { UserStorageService } from './services/user-storage.service';
import { OrganizationService } from './services/organization.service';
import { EmailConfirmationService } from './services/email-confirmation.service';
import { RecoveryService } from './services/recovery.service';
import { HandleLoggedUserGuard } from './services/handle-logged-user-guard.service';

import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';

import { routing } from './user.routing';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    routing,
    CustomFormsModule,
    SharedModule,
    MaterialModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    LoginComponent,
    PoliticaPrivacidadeComponent,
    RedefinirSenhaComponent,
    ChangePasswordComponent,
    AuthSsoComponent,
    EsqueciMinhaSenhaComponent,
  ],
  providers: [
    AuthService,
    Oauth2TokenService,
    LocalStorageService,
    DefaultRequestOptionsService,
    UserWebService,
    LoginService,
    OAuthService,
    UserStorageService,
    OrganizationService,
    RecoveryService,
    EmailConfirmationService,
    HandleLoggedUserGuard,
  ],
})
export class UserModule {}
